import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SizesDto } from './sizes-dto';


export class AllSizesResponse extends GlobalResponseObject{
    data?: SizesDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: SizesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

